import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { PropertyRow } from '@/shared/components/ui/PropertyRow';
import { SeveritySelector } from './SeveritySelector';

interface SeverityFieldProps {
  value: number;
  onChange: (value: number) => void;
}

export const SeverityField = ({ value, onChange }: SeverityFieldProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <PropertyRow
      icon={<AlertTriangle />}
      label={t('severityLabel')}
      tooltip={t('severityTooltip')}
    >
      <SeveritySelector value={value} onChange={onChange} />
    </PropertyRow>
  );
};
